module.exports = {
    GET_QUERIES: 'GET_QUERIES',
    EXPLAIN_QUERY: 'EXPLAIN_QUERY'
}
